import { render, staticRenderFns } from "./TaskPredecessors2.vue?vue&type=template&id=647d12b6&scoped=true&"
import script from "./TaskPredecessors2.vue?vue&type=script&lang=js&"
export * from "./TaskPredecessors2.vue?vue&type=script&lang=js&"
import style0 from "./TaskPredecessors2.vue?vue&type=style&index=0&id=647d12b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647d12b6",
  null
  
)

export default component.exports